import ProcessContent from "./ProcessContent";

//repreater block wrapper
const Process = ({data})  => {
    return(
        <>
        <section className="processes text-center p-top-70">
            <div className="container">
                <ProcessContent processContent={data}></ProcessContent>
            </div>
        </section>
        </>
    );
}

export default Process;